export default __webpack_public_path__ + "static/dumpster-rental-single-3c24e00043452e631af749ef0ea2dbed.jpg";